export default {
  setMillisecondsToEvent(state, value) {
    state.millisecondsToEvent = value > 0 ? value : 0;
  },
  setEventStartTimerInterval(state, value) {
    if (state.eventStartTimerInterval) {
      clearInterval(state.eventStartTimerInterval);
    }
    state.eventStartTimerInterval = value;
  }
};
